module.exports = __webpack_public_path__ + "fd368300577d973c09541faa0eb52434.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/plate-colorpicker/img/metal-color-antique.png
// module id = Ht4O
// module chunks = 5